import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontSize, fontText, hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {},
  withMarks: {
    paddingBottom: 0,
  },
  marksContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  markLabel: {
    color: theme.color.greys[80],
    font: fontText('normal', fontSize.s, 20),
  },
  valueLabel: {
    backgroundColor: theme.color.greys[80],
    color: theme.color.greys[0],
    padding: '6px 12px',
    borderRadius: 8,
    font: fontText('normal', fontSize.l, 24),
    '& *': {
      transform: 'none !important',
    }
  },
  slider: {
    backgroundColor: theme.color.greys[0],
    height: 8,
    padding: 0,
    '&.MuiSlider-marked': {
      marginBottom: 0
    },
    '& .MuiSlider-rail': {
      opacity: 1,
      height: 8,
      borderRadius: 8,
      backgroundColor: theme.color.greys[15],
    },

    '& .MuiSlider-thumb': {
      position: 'relative',
      width: 24,
      height: 24,
      backgroundColor: theme.color.greys[0],
      border: `1px solid ${theme.color.greys[40]}`,
      boxShadow: `0px 2px 8px 2px ${hexToRgbA(theme.color.greys[80], 0.16)}`,
      marginTop: -8,
      marginLeft: -12,
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: theme.color.greys[15]
      },
      '&.MuiSlider-active': {
        boxShadow: 'none',
        backgroundColor: theme.color.greys[20],
      },
      '&.Mui-focusVisible': {
        backgroundColor: theme.color.greys[0],
        boxShadow: 'none',
        borderColor: theme.color.greys[80],
        outline: `1px solid ${theme.color.greys[80]}`,
      },
    },
    '& .MuiSlider-root': {
      height: 20,
      marginBottom: 0,
    },
    '& .MuiSlider-track': {
      backgroundColor: theme.color.oranges[50],
      height: 8,
      borderRadius: 8,
    },
    '& .MuiSlider-mark': {
      display: 'none',
    },
    '& .MuiSlider-markLabel': {
      display: 'none',
    },
    '&.Mui-disabled': {
      '& .MuiSlider-track': {
        backgroundColor: theme.color.oranges[10],
      },
      '& .MuiSlider-rail': {
        backgroundColor: theme.color.greys[10],
      },
      '& .MuiSlider-thumb': {
        backgroundColor: theme.color.greys[0],
        borderColor: theme.color.greys[20],
      },
      '& .MuiSlider-valueLabel': {
        '&:after': {
          borderTopColor: theme.color.greys[30],
        },
        '& > span': {
          backgroundColor: theme.color.greys[30],
        }
      }
    },
    '& .MuiSlider-valueLabel': {
      top: -26,
      left: '50%',
      transform: 'translateX(-50%) scale(1) translateY(-10px) !important',
      '&:after': {
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        position: 'absolute',
        bottom: -6,
        left: '50%',
        marginLeft: -6,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: `6px solid ${theme.color.greys[80]}`,
      },
      '& > span ': {
        transform: 'none',
        borderRadius: 4,
        height: 24,
        minWidth: 32,
        width: 'auto',
        padding: '0 6px',
        backgroundColor: theme.color.greys[80],
        '& > span': {
          transform: 'none',
          font: fontText('normal', fontSize.s, 20),
          color: theme.color.greys[0],
        }
      },
    },
  },
  sliderWrapper: {
    height: 48,
    padding: 12,
    borderRadius: 8,
    backgroundColor: theme.color.greys[0],
    border: `1px solid ${theme.color.greys[15]}`,
  },
}), { name: 'Slider', index: StylesIndexInjections.UI_ATOMS });
